module.exports = {
      id: "star-usage",
      viewBox: "0 0 36.688 45.344",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#star",
      toString: function () {
        return this.url;
      }
    }